export function getFirstDayOfWeek(d) {
    // clone date object, so we don't mutate it
    var date = new Date(d);
    var day = date.getDay(); // get day of week
    // day of month - day of week (-6 if Sunday), otherwise +1
    var diff = date.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(date.setDate(diff));
}
